import React from 'react';
export default function ContactPage() {
return (

<div style={{ padding: '2rem' }}> <h2>Contact</h2> <p>Reach us at contact@saisruthi.example (dummy).</p> </div> );
}